import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SharedService } from '.';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ManageWorkflowsService {

    constructor(public http: HttpClient, private sharedService: SharedService) { }

    addPowerAutomateFlows(masterCommunityId: number): Observable<any> {
        const opts = this.sharedService.getOpts();
        const getUrl = environment.baseUrl + '/ManageWorkflows/';
        return this.http.get(`${getUrl}AddPowerAutomateFlows/${masterCommunityId}`, opts);
    }

    getSharePointSiteInformation(masterCommunityId: number): Observable<any> {
        const opts = this.sharedService.getOpts();
        const getUrl = environment.baseUrl + '/ManageWorkflows/';
        return this.http.get(`${getUrl}GetSharePointSiteInformation/${masterCommunityId}`, opts);
    }
}